import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, light = false }) => (
  <span
    className={`inline-flex items-center gap-2 font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] ${
      light ? "text-dg-blue" : "text-dg-cyan"
    }`}
  >
    <span className={`h-px w-8 ${light ? "bg-dg-blue" : "bg-dg-cyan"}`} />
    {children}
  </span>
);

export const SectionHead = ({ eyebrow, title, sub, light = false, align = "left" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-12 sm:mb-16`}>
    {align === "center" ? (
      <div className="flex justify-center"><Eyebrow light={light}>{eyebrow}</Eyebrow></div>
    ) : (
      <Eyebrow light={light}>{eyebrow}</Eyebrow>
    )}
    <h2 className={`font-display mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight ${light ? "text-dg-navy" : "text-white"}`}>
      {title}
    </h2>
    {sub && (
      <p className={`mt-4 text-base sm:text-lg leading-relaxed ${light ? "text-slate-600" : "text-slate-400"}`}>{sub}</p>
    )}
  </Reveal>
);

export const PageHero = ({ eyebrow, title, sub }) => (
  <section className="relative overflow-hidden bg-dg-navy bg-grid-dark pt-36 pb-20 sm:pt-44 sm:pb-24 noise">
    <div className="absolute -top-40 left-1/2 h-96 w-[42rem] -translate-x-1/2 rounded-full bg-dg-blue/30 blur-[140px]" />
    <div className="absolute top-20 right-0 h-64 w-64 rounded-full bg-dg-cyan/10 blur-[100px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 className="font-display mt-5 max-w-4xl text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-white">
        <LineReveal delay={0.1}>{title}</LineReveal>
      </h1>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-400"
        >
          {sub}
        </motion.p>
      )}
    </div>
  </section>
);
